import { PaginatedQueryParams, usePaginatedQuery } from '@/hooks/use-paginated-query';
import PermissionData from '@/types/Permission/PermissionData';

type Params = PaginatedQueryParams;

export const useGetPermissionsQuery = ({ dispatchPagination, ...params }: Params) => {
  return usePaginatedQuery<PermissionData>({
    queryKey: [
      'admin/permission',
      JSON.stringify(params.filter),
      params.current,
      params.pageSize,
      params.search,
      JSON.stringify(params.sort),
    ],
    url: 'admin/permission',
    permissions: ['admin.permission.index'],
    staleTime: 1000,
    params: {
      ...params,
      dispatchPagination,
    },
  });
};
